window.sendTrackingEvent = function(a){var b=a.getAttribute("data-track-category"),c=a.getAttribute("data-track-action"),d=a.getAttribute("data-track-label");return function(){ga("send","event",b,c,d)}};
